import { render, staticRenderFns } from "./FieldInfoTypeB.vue?vue&type=template&id=01bdf42c&scoped=true&"
import script from "./FieldInfoTypeB.vue?vue&type=script&lang=js&"
export * from "./FieldInfoTypeB.vue?vue&type=script&lang=js&"
import style0 from "./FieldInfoTypeB.vue?vue&type=style&index=0&id=01bdf42c&prod&scoped=true&lang=scss&"
import style1 from "./FieldInfoTypeB.vue?vue&type=style&index=1&id=01bdf42c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bdf42c",
  null
  
)

export default component.exports